var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"d-flex flex-column align-center justify-center pb-5"},[_c('img',{attrs:{"src":require('../../assets/logoDigiLab.png'),"height":"25"}}),_c('icons',{staticClass:"mt-n2",attrs:{"icon":"loading"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }